/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

export const Disclaimer = 'https://www.volcengine.com/docs/6348/68916';
export const ReversoContext = 'https://www.volcengine.com/docs/6348/68918';
export const UserAgreement = 'https://www.volcengine.com/docs/6348/128955';

/**
 * @note 请求的 API Proxy Server(对应此 Demo 中包含的 Node server) 地址。
 *       您可按需改成自己需要访问的地址。
 */
// CRA env is build-time: use REACT_APP_AIGC_PROXY_HOST to point to your proxy.
// Recommended for intranet deployment: set it to '' (same-origin) and let Nginx reverse-proxy
// `/proxy` + `/getScenes` to the backend, so there is no CORS.
const isProd = process.env.NODE_ENV === 'production';
export const AIGC_PROXY_HOST =
  process.env.REACT_APP_AIGC_PROXY_HOST || (isProd ? '' : 'http://localhost:3001');

export interface IScene {
  icon: string;
  name: string;
  questions: string[];
  agentConfig: Record<string, any>;
  llmConfig: Record<string, any>;
  asrConfig: Record<string, any>;
  ttsConfig: Record<string, any>;
}
